import { Box } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

export interface ExampleItem {
  label: string;
  points: string;
  isPositive: boolean;
}

interface EducationExampleCardProps {
  examples: ExampleItem[];
}

export function EducationExampleCard(props: EducationExampleCardProps) {
  const { examples } = props;

  return (
    <Box
      sx={{
        width: "100%",
        paddingTop: 12,
        paddingX: 2,
      }}
    >
      <Box
        sx={(theme) => ({
          backgroundColor: isRebrandingEnabled()
            ? theme.palette.background.tertiary
            : theme.palette.background.paper,
          borderRadius: "25px",
          padding: theme.spacing(6),
          boxShadow: isRebrandingEnabled() ? "none" : "0px 4px 4px 0px rgba(0,0,0,0.05)",
          ...(isRebrandingEnabled() && {
            border: `1px solid ${theme.palette.border?.primary}`,
          }),
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          minHeight: "70px",
        })}
      >
        <Text
          sx={(theme) => ({
            fontSize: "14px",
            fontWeight: 500,
            color: theme.palette.text.tertiary,
            lineHeight: "16px",
            textAlign: "left",
            paddingLeft: theme.spacing(1),
          })}
        >
          Example:
        </Text>
        {examples.map((example) => (
          <Box
            key={example.label}
            sx={(theme) => ({
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              paddingRight: theme.spacing(1),
            })}
          >
            <Text
              sx={(theme) => ({
                fontSize: "16px",
                fontWeight: 500,
                color: theme.palette.text.primary,
                lineHeight: "17px",
                paddingLeft: theme.spacing(1),
              })}
            >
              {example.label}
            </Text>
            <Box
              sx={(theme) => ({
                backgroundColor: example.isPositive
                  ? theme.palette.intent?.success.background
                  : theme.palette.intent?.error.background,
                borderRadius: "100px",
                paddingX: theme.spacing(3),
                paddingY: theme.spacing(0.75),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "22px",
              })}
            >
              <Text
                sx={(theme) => ({
                  fontSize: "12px",
                  fontWeight: 500,
                  color: example.isPositive
                    ? theme.palette.intent?.success.text
                    : theme.palette.intent?.error.text,
                  lineHeight: "14.5px",
                })}
              >
                {example.points} pts
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
